import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = { class: "main-nav" }
const _hoisted_4 = { class: "menu-header" }
const _hoisted_5 = { class: "app-main" }
const _hoisted_6 = { class: "app-footer" }

import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import HeaderVue from './components/public/header.vue';
import FooterVue from './components/public/footer.vue';
import { routerList } from '@/pubilc/data';
import emitter from '@/plugins/emitter';
import { Close } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const activeIndex = ref(route.path);
const isMobileMenuOpen = ref(false);
const isMobile = ref(false);
const touchStartX = ref(0);

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

const updateActiveIndex = () => {
  activeIndex.value = route.path;
};

const handleTouchStart = (e: TouchEvent) => {
  touchStartX.value = e.touches[0].clientX;
};

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

const handleClickOutside = (event: MouseEvent) => {
  const handle = document.querySelector('.mobile-menu-handle');
  const menuWrapper = document.querySelector('.mobile-menu-wrapper');

  if (handle && !handle.contains(event.target as Node) &&
    menuWrapper && !menuWrapper.contains(event.target as Node)) {
    closeMobileMenu();
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
  document.addEventListener('click', handleClickOutside);
  emitter.on('route-change', updateActiveIndex);
  updateActiveIndex();

  // 触摸滑动显示控制
  document.addEventListener('touchmove', (e) => {
    if (touchStartX.value > 0 && e.touches[0].clientX - touchStartX.value > 30) {
      // 保持按钮显示
    }
  });

  document.addEventListener('touchend', () => {
    touchStartX.value = 0;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile);
  document.removeEventListener('click', handleClickOutside);
  emitter.off('route-change', updateActiveIndex);
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(HeaderVue),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_el_menu, {
          class: "desktop-menu",
          "default-active": activeIndex.value,
          mode: "horizontal",
          router: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routerList), (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (!item.children)
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: item.path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  : (_openBlock(), _createBlock(_component_el_sub_menu, {
                      key: 1,
                      index: item.path
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: childIndex }, [
                            (!child.children)
                              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: 0,
                                  index: child.path
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                                  key: 1,
                                  index: child.path
                                }, {
                                  title: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(child.name), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandChild, grandIndex) => {
                                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                                        key: grandIndex,
                                        index: grandChild.path
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(grandChild.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["index"]))
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["mobile-menu-handle", { 'active': isMobileMenuOpen.value }]),
      onTouchstart: handleTouchStart
    }, [
      _createElementVNode("div", {
        class: "mobile-menu-floating-btn",
        onClick: toggleMobileMenu
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "hamburger" }, [
          _createElementVNode("span", { class: "line line1" }),
          _createElementVNode("span", { class: "line line2" }),
          _createElementVNode("span", { class: "line line3" })
        ], -1)
      ]))
    ], 34), [
      [_vShow, isMobile.value]
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "mobile-menu-wrapper",
          onClick: _withModifiers(closeMobileMenu, ["self"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mobile-menu-container", { 'active': isMobileMenuOpen.value }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("h3", null, "网站导航", -1)),
              _createVNode(_component_el_icon, {
                class: "close-icon",
                onClick: closeMobileMenu
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_menu, {
              class: "mobile-menu",
              "default-active": activeIndex.value,
              router: true,
              "background-color": "#f8fafc",
              "text-color": "#334155",
              "active-text-color": "#1373C0"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routerList), (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (!item.children)
                      ? (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: 0,
                          index: item.path,
                          onClick: closeMobileMenu
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      : (_openBlock(), _createBlock(_component_el_sub_menu, {
                          key: 1,
                          index: item.path
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, childIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: childIndex }, [
                                (!child.children)
                                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                      key: 0,
                                      index: child.path,
                                      onClick: closeMobileMenu
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(child.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["index"]))
                                  : (_openBlock(), _createBlock(_component_el_sub_menu, {
                                      key: 1,
                                      index: child.path
                                    }, {
                                      title: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(child.name), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandChild, grandIndex) => {
                                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                                            key: grandIndex,
                                            index: grandChild.path,
                                            onClick: closeMobileMenu
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(grandChild.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["index"]))
                              ], 64))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["default-active"])
          ], 2)
        ], 512), [
          [_vShow, isMobileMenuOpen.value && isMobile.value]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_6, [
      _createVNode(FooterVue)
    ])
  ]))
}
}

})